import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import type { AdminActionItem } from '@pkg-framework/models/admin';

@Component({
  selector: 'app-admin-action-list',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './admin-action-list.component.html',
  styleUrl: './admin-action-list.component.scss',
})
export class AdminActionListComponent {
  @Input() items: AdminActionItem[] = [];
  @Input() compact = false;
  @Input() emptyMessage = 'Aucune action urgente — tout est à jour.';

  severityClass(sev: string): string {
    if (sev === 'critical') return 'aal-sev aal-sev--critical';
    if (sev === 'high') return 'aal-sev aal-sev--high';
    if (sev === 'medium') return 'aal-sev aal-sev--medium';
    return 'aal-sev';
  }
}
